import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  transactAsPayer,
  TRANSACT_AS_PAYER,
  selector,
} from 'reducers/transactAs';
import { useFSPId } from 'hooks';
import { profileSelector } from 'selectors/payer';
import { withTransactAsPayerPermission } from 'components/common/permissions';
import ConfirmDialog from './ConfirmDialog';
import PayerOrPayerUserButton from '../PayerOrPayerUserButton';
import { buildEnrolledPalContext } from './palContext';

const TransactAsButton = ({
  payerId,
  recipientId,
  payeeId,
  transactionId,
  transactionType,
  loanId,
  loanNumber,
  accountSuffix,
  email,
  fspIdValue,
}) => {
  const payer = useSelector((state) => profileSelector(state, { id: payerId }));
  const dispatch = useDispatch();
  const [confirmData, setConfirmData] = useState();
  const fspIdQueryString = useFSPId();
  const fspId = Number.isNaN(fspIdQueryString) ? fspIdValue : fspIdQueryString;

  const handlePayerUserClick = (event, payerUser = {}) => {
    const shouldIncludeEnrolledPalContext =
      loanId || loanNumber != null || accountSuffix != null || email != null;
    const enrolledPalContext = shouldIncludeEnrolledPalContext
      ? buildEnrolledPalContext({
          payer,
          loanNumber,
          accountSuffix,
          email,
        })
      : {};
    const data = {
      fspId,
      payerId,
      userId: payerUser.userId,
      payerUser,
      recipientId,
      payeeId,
      transactionId,
      transactionType,
      loanId,
      ...enrolledPalContext,
      sso: 'on',
    };
    setConfirmData(transactAsPayer(data));
  };

  const handleCancel = useCallback(
    () => setConfirmData(undefined),
    [setConfirmData]
  );
  const handleConfirm = useCallback(
    () => dispatch(confirmData),
    [dispatch, confirmData]
  );
  return (
    <>
      <ConfirmDialog
        fspId={fspId}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        open={Boolean(confirmData)}
        ownerType={payer?.ownerType}
        payerName={payer?.name || ''}
      />
      <PayerOrPayerUserButton
        fspId={fspId}
        onPayerClick={handlePayerUserClick}
        onPayerUserClick={handlePayerUserClick}
        payerAction={TRANSACT_AS_PAYER}
        payerButtonText="Transact As Payer"
        payerId={payerId}
        payerType={payer?.payerType}
        payerUserAction={TRANSACT_AS_PAYER}
        payerUserButtonText="Transact As User"
        selector={selector}
        transactAs
      />
    </>
  );
};

TransactAsButton.propTypes = {
  payerId: PropTypes.number.isRequired,
  recipientId: PropTypes.number,
  payeeId: PropTypes.number,
  transactionId: PropTypes.number,
  transactionType: PropTypes.string,
  loanId: PropTypes.number,
  loanNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  accountSuffix: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  email: PropTypes.string,
  fspIdValue: PropTypes.number,
};

TransactAsButton.defaultProps = {
  recipientId: null,
  payeeId: null,
  transactionId: null,
  transactionType: null,
  loanId: null,
  loanNumber: null,
  accountSuffix: null,
  email: null,
  fspIdValue: null,
};

export default withTransactAsPayerPermission(TransactAsButton);
